import { Spinner } from '@sbab-ui/components'
import { useEffect, useReducer } from 'react'
import { fetchMortgageTerms, fetchThreeMonthMortgageRates } from '../../../api/httpHandlers'
import { initialState, reducer } from './interestRateAppState'
import EffectiveRateAccordionSection from './subcomponents/EffectiveRateAccordionSection/EffectiveRateAccordionSection'
import FormSection from './subcomponents/FormSection/FormSection'
import TableSection from './subcomponents/TableSection'
import TopSection from './subcomponents/TopSection'

export default function App() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    status,
    mortgageTerms,
    userValues,
    threeMonthInterestRate,
    priceMatrixDifference,
    kilowattLoanDifference,
    effectiveInterest,
    hasFetchedSucessfully,
  } = state
  useEffect(() => {
    async function getAppData() {
      const [mortgageRatesResult, mortgageTermsResult] = await Promise.all([
        fetchThreeMonthMortgageRates(),
        fetchMortgageTerms(),
      ])
      if (mortgageRatesResult.successful && mortgageTermsResult.successful) {
        dispatch({
          type: 'appDataFetched',
          mortgageTerms: mortgageTermsResult.data,
          threeMonthInterestRate: mortgageRatesResult.threeMonthInterestRate,
        })
      } else {
        console.error('Could not fetch interest rates')
        dispatch({ type: 'error' })
      }
    }
    getAppData().catch(() => {
      dispatch({ type: 'error' })
    })
  }, [])

  if (status === 'initializing' || !mortgageTerms)
    return (
      <section className="flex h-96 items-center justify-center">
        <Spinner size="large" data-testid="spinner" />
      </section>
    )

  const { wantedLoanAmount } = userValues
  const blur = status === 'fetching' || status === 'userIsTyping' || status === 'formError'

  return (
    <section className="flex flex-col gap-6 md:gap-8">
      <TopSection />
      <FormSection
        state={state}
        dispatch={dispatch}
        status={status}
        mortgageTerms={mortgageTerms}
        blur={blur}
      />
      {hasFetchedSucessfully && (
        <>
          <TableSection
            wantedLoanAmount={wantedLoanAmount}
            threeMonthInterestRate={threeMonthInterestRate}
            priceMatrixDifference={priceMatrixDifference}
            kilowattLoanDifference={kilowattLoanDifference}
            effectiveInterest={effectiveInterest}
            blur={blur}
          />
          <EffectiveRateAccordionSection
            userValues={userValues}
            threeMonthInterestRate={threeMonthInterestRate}
            priceMatrixDifference={priceMatrixDifference}
            effectiveInterest={effectiveInterest}
            blur={blur}
          />
        </>
      )}
    </section>
  )
}
